import React from 'react';
import { Link } from 'react-router-dom';

interface LocationLinksProps {
  currentCity?: string;
  currentState?: string;
  className?: string;
}

const locations = [
  { city: 'New York', state: 'NY', route: '/chauffeur-new-york-ny' },
  { city: 'Boston', state: 'MA', route: '/chauffeur-boston-ma' },
  { city: 'Philadelphia', state: 'PA', route: '/chauffeur-philadelphia-pa' },
  { city: 'Washington DC', state: 'DC', route: '/chauffeur-washington-dc' },
  { city: 'Portland', state: 'ME', route: '/chauffeur-portland-me' },
  { city: 'Cambridge', state: 'MA', route: '/chauffeur-cambridge-ma' },
  { city: 'Albany', state: 'NY', route: '/chauffeur-albany-ny' },
  { city: 'Bangor', state: 'ME', route: '/chauffeur-bangor-me' },
  { city: 'Pittsburgh', state: 'PA', route: '/chauffeur-pittsburgh-pa' },
  { city: 'Princeton', state: 'NJ', route: '/chauffeur-princeton-nj' }
];

const LocationLinks: React.FC<LocationLinksProps> = ({ currentCity, currentState, className = '' }) => {
  // Filter out current location and get nearby cities
  const nearbyLocations = locations.filter(loc => 
    loc.city !== currentCity && 
    (loc.state === currentState || 
     // Add logic for nearby states
     (currentState === 'NY' && ['NJ', 'MA', 'PA'].includes(loc.state)) ||
     (currentState === 'MA' && ['NY', 'ME', 'RI'].includes(loc.state)) ||
     (currentState === 'PA' && ['NY', 'NJ', 'MD'].includes(loc.state)) ||
     (currentState === 'ME' && ['MA', 'NH'].includes(loc.state)) ||
     (currentState === 'NJ' && ['NY', 'PA'].includes(loc.state)) ||
     (currentState === 'DC' && ['MD', 'VA'].includes(loc.state)))
  ).slice(0, 3);

  return (
    <div className={`grid grid-cols-1 md:grid-cols-3 gap-4 ${className}`}>
      {nearbyLocations.map(({ city, state, route }) => (
        <Link
          key={route}
          to={route}
          className="bg-gray-900 p-4 rounded-lg hover:bg-gray-800 transition-colors"
        >
          <h3 className="text-xl font-semibold text-gold mb-2">
            {city}, {state}
          </h3>
          <p className="text-white/80">
            Luxury chauffeur service in {city}
          </p>
        </Link>
      ))}
    </div>
  );
};

export const AllLocationLinks: React.FC<{ className?: string }> = ({ className = '' }) => {
  return (
    <div className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 ${className}`}>
      {locations.map(({ city, state, route }) => (
        <Link
          key={route}
          to={route}
          className="bg-gray-900 p-4 rounded-lg hover:bg-gray-800 transition-colors"
        >
          <h3 className="text-xl font-semibold text-gold mb-2">
            {city}, {state}
          </h3>
          <p className="text-white/80">
            Premium transportation in {city}
          </p>
        </Link>
      ))}
    </div>
  );
};

export default LocationLinks; 